import { Avatar, Box, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'
import ICPSwapLogo from '@plug-core/assets/icons/icpswap.png'

import React from 'react'
import { SwapProvider } from '@plug-core/interfaces/swapInterface'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import { useTranslation } from 'react-i18next'

const ProviderPicker = () => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const renderProviderRow = (provider: string, logo: string) => (
    <Box key={provider}>
      <ListItem
        key={provider}
        onClick={() => navigate(ROUTES.SWAP_FALLBACK_PAIR_SELECT, { state: { provider } })}
      >
        <ListItemIcon>
          <Avatar src={logo} />
        </ListItemIcon>
        <ListItemText primary={provider} />
      </ListItem>
    </Box>
  )

  return (
    <Stack mx={2}>
      {renderProviderRow(SwapProvider.ICPSWAP, ICPSwapLogo)}
      <Typography mt={1} textAlign="center" color={(theme) => theme.palette.text.secondary}>
        {t('swap.kongFallback')}
      </Typography>
    </Stack>
  )
}

export default ProviderPicker
